import SubscriptionSection from '../settings/SubscriptionSection';
import { useT } from '../i18n/i18n';

export default function SubscriptionPage() {
  const t = useT();
  return (
    <section aria-labelledby="sub-page-h" style={{ maxWidth: 640, margin: '0 auto' }}>
      <h2 id="sub-page-h" className="visually-hidden">{t('Subscription')}</h2>
      <SubscriptionSection />
    </section>
  );
}
